import * as React from 'react';


import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function Profile() {
    return (
        <div >
            <h1>Miscellaneous </h1>

        </div>
    );
}

export default Profile;
